import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { pushModal } from 'redux/modules/modal';
import { Dispatch } from 'redux/types';
import { AutogramSubscriptionOptions, DeepPartial } from 'types';

export interface UseTikTokAutomationAuthenticatorResults {
  authenticate: () => Promise<DeepPartial<AutogramSubscriptionOptions>>;
}

export default function useTikTokAutomationAuthenticator(): UseTikTokAutomationAuthenticatorResults {
  const reduxDispatch = useDispatch<Dispatch>();

  const authenticate = useCallback(async (): Promise<
    DeepPartial<AutogramSubscriptionOptions>
  > => {
    const result = await reduxDispatch(
      pushModal({
        name: 'TikTokAutoPost',
      }),
    );

    if (result) {
      return {
        autopost: result,
      };
    }

    return undefined;
  }, [reduxDispatch]);

  return {
    authenticate,
  };
}
